import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import { NotificationManager } from "react-notifications";
import { makeStyles } from "@mui/styles";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import useEquipmentsTable from "./useEquipmentsTable.js";
import styled from "styled-components";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import UserService from "services/UserService";
import { getMBMIotdevices, getMBMEquipmentAlarms } from "services/ConfigServices";
import { equipmenttext } from "variables/MBM/equipments";
import { definitionData, hardwareData } from "variables/MBM/lists/equipments";
import { withStyles } from "@mui/styles";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import PowerIcon from '@mui/icons-material/Power';
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
import SignalCellularAlt2BarIcon from '@mui/icons-material/SignalCellularAlt2Bar';
import SignalCellularAlt1BarIcon from '@mui/icons-material/SignalCellularAlt1Bar';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import NotificationsIcon from '@mui/icons-material/Notifications';
import CheckSharpIcon from '@mui/icons-material/CheckSharp';
import Dialog from '@mui/material/Dialog';
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import ViewEquipmentAlarmsDialog from "components/MBM/EquipmentAlarms/ViewEquipmentAlarmsDialog.js";


const Container = styled.div`
  border: solid;
  border-width: 1px;
  border-color: #EEEEEE;
  background-color: white;
  margin-top: -0.5px;
  padding-top: 5px;
  overflow-x: auto;
  width: 100%;
`;

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;

const useStyles2 = makeStyles((theme) => ({
  "@keyframes flicker": {
    from: {
      opacity: 1
    },
    to: {
      opacity: 0.7
    }
  },
  flicker: {
    animationName: "$flicker",
    animationDuration: "1000ms",
    animationIterationCount: "infinite",
    animationDirection: "alternate",
    animationTimingFunction: "ease-in-out"
  },
  withAnimation: ({ disabled }) => ({
    animationPlayState: disabled ? "paused" : "running"
  })
}));

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const useStyles = makeStyles(styles);

const RTEquipments = (props) => {
  const currentusertype = localStorage.getItem('userType');
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const mbm_geb_control_schedules = permis.includes("mbm_geb_control_schedules");
  const mbm_geb_control_admin_override = permis.includes("mbm_geb_control_admin_override");
  const appContext = useContext(AdvancedSearchContext);
  const { groupInfoListById } = appContext;
  const { wpgroup, workspace } = props;
  const [iotdata, setIotdata] = useState([]);
  const [alarmsdata, setAlarmsdata] = useState([]);
  const { gridState, refetch, setEquipments, setPoints, pointsdata, equipmentsdata, displaymethod } = useEquipmentsTable(wpgroup, workspace, iotdata, alarmsdata);
  const [alertopen, setAlertopen] = useState(false);
  const [equipmentalarmsdata, setEquipmentalarmsdata] = useState([]);
  const [refreshAlarms, setRefreshAlarms] = useState(true);

  useEffect(() => {
    if (wpgroup > 0) {
      axios
        .get(
          getMBMIotdevices(wpgroup, workspace.id),
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        )
        .then((res) => {
          setIotdata(res.data.iotdevices || []);
        })
        .catch(() => { });
    }
  }, [wpgroup]);

  const handleRefreshAlarms = () => {
    setRefreshAlarms(true);
  }
  useEffect(() => {
    if (wpgroup > 0) {
      console.log(refreshAlarms);
      if (!refreshAlarms) {
        return;
      }
      axios
        .get(
          getMBMEquipmentAlarms(wpgroup, workspace.id),
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        )
        .then((res) => {
          setAlarmsdata(res.data.alarms || []);
        })
        .catch(() => { });
      setRefreshAlarms(false);
    }
  }, [wpgroup, refreshAlarms]);

  const getLastConnectionStyle = (lastconnection) => {
    if (lastconnection && moment(lastconnection).isValid()) {
      if (moment(lastconnection) < moment().add(-1, 'd')) {
        return { color: "#f44336" };
      }
      else {
        return { color: "#000000" };
      }
    }
  }
  const getBatteryStyle = (batterylevel) => {
    if (batterylevel) {
      if (batterylevel < 50) {
        return { color: "#f44336" };
      }
      else if (batterylevel < 75) {
        return { color: "#FF763A" };
      }
      else {
        return { color: "#000000" };
      }
    }
  }

  const handleClickAlertOpen = () => {
    setAlertopen(true);
  };
  const handleClickAlertClose = () => {
    setAlertopen(false);
  };

  const equipmentscolumns = [
    {
      name: equipmenttext.name,
      selector: (row) => row.name,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.name,
    },
    {
      name: equipmenttext.definition,
      selector: (row) => row.definition,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => definitionData.find((x) => x.id == row.definition)?.name || ""
    },
    {
      name: equipmenttext.hardware,
      selector: (row) => row.otherproperties?.hardware ? hardwareData.find((a) => a.id == row.otherproperties.hardware)?.name || equipmenttext.undefinedhardware : equipmenttext.undefinedhardware,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => row.otherproperties?.hardware ? hardwareData.find((a) => a.id == row.otherproperties.hardware)?.name || equipmenttext.undefinedhardware : equipmenttext.undefinedhardware
    },
    {
      name: equipmenttext.lastconnection,
      selector: (row) => row.lastconnection && moment(row.lastconnection).isValid() ? row.lastconnection : 0,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) =>
        row.lastconnection && moment(row.lastconnection).isValid()
          ? <div style={getLastConnectionStyle(row.lastconnection)}>{moment(row.lastconnection).format("DD/MM/YYYY HH:mm")}</div>
          : "",
    },
    // {
    //   name: equipmenttext.fieldprotocol,
    //   selector: (row) => row.connectionproperties?.fieldProtocol,
    //   sortable: true,
    //   maxWidth: "12rem",
    //   cell: (row) => fieldprotocoleData.find((x) => x.id == row.connectionproperties?.fieldProtocol)?.name || ""
    // },
    // {
    //   name: equipmenttext.eosprotocol,
    //   selector: (row) => row.connectionproperties?.eosprotocol,
    //   sortable: true,
    //   maxWidth: "12rem",
    //   cell: (row) => eosprotocoleData.find((x) => x.id == row.connectionproperties?.eosprotocol)?.name || ""
    // },
    {
      name: equipmenttext.iot,
      selector: (row) => iotdata.find((x) => x.id == row.connectionproperties?.iotdevice)?.name || "",
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => iotdata.find((x) => x.id == row.connectionproperties?.iotdevice)?.name || "N/A"
    },
    // {
    //   name: equipmenttext.iotbattery,
    //   selector: (row) => row.connectionproperties?.fieldProtocol,
    //   sortable: true,
    //   maxWidth: "8rem",
    //   cell: (row) => iotdata.find((x) => x.id == row.connectionproperties?.iotdevice)?.status ?
    //     (iotdata.find((x) => x.id == row.connectionproperties.iotdevice).status.externalpowersource === 'true' ? <><PowerIcon fontSize="medium" /></>
    //       : (iotdata.find((x) => x.id == row.connectionproperties.iotdevice).status.deviceStatusbatterylevel + '%')) : ""
    // },
    {
      name: equipmenttext.iotbattery,
      selector: (row) => {
        let iot = iotdata.find((x) => x.id == row.connectionproperties?.iotdevice);
        let display = 0;
        if (iot) {
          if (iot?.status?.externalpowersource === 'true')
            display = 100;
          else if (iot.status.deviceStatusbatterylevel)
            display = iot.status.deviceStatusbatterylevel;
        }
        return display;
      },
      sortable: true,
      maxWidth: "6rem",
      cell: (row) => {
        let iot = iotdata.find((x) => x.id == row.connectionproperties?.iotdevice);
        let display = "";
        if (iot) {
          if (iot?.status?.externalpowersource === 'true') {
            display = <><PowerIcon fontSize="medium" /></>;
          }
          else {
            if (iot.status.deviceStatusbatterylevel)
              display = <div style={getBatteryStyle(iot.status.deviceStatusbatterylevel)}>{iot.status.deviceStatusbatterylevel + '%'}</div>;
          }
        }
        else
          display = 'N/A';
        return display;
      }
    },
    {
      name: equipmenttext.iotsignal,
      selector: (row) => {
        let iot = iotdata.find((x) => x.id == row.connectionproperties?.iotdevice);
        let display = -999;
        if (iot?.status?.margin != null) {
          display = iot.status.margin;
        }
        return display;
      },
      sortable: true,
      maxWidth: "8rem",
      cell: (row) => {
        let iot = iotdata.find((x) => x.id == row.connectionproperties?.iotdevice);
        let display = "";
        if (!iot)
          display = 'N/A';
        else if (iot?.status?.margin != null) {
          if (iot.status.margin >= 0) {
            display = <Tooltip title={iot.status.margin + " db"}><SignalCellularAltIcon sx={{ color: "#91c241" }} fontSize="medium" /></Tooltip>;
          }
          else if (iot.status?.margin >= -10) {
            display = <Tooltip title={iot.status.margin + " db"}><SignalCellularAlt2BarIcon sx={{ color: "#FF763A" }} fontSize="medium" /></Tooltip>;
          }
          else {
            display = <Tooltip title={iot.status.margin + " db"}><SignalCellularAlt1BarIcon sx={{ color: "#f44336" }} fontSize="medium" /></Tooltip>;
          }
        }
        return display;
      }
    },
    {
      name: equipmenttext.alarms,
      selector: (row) => alarmsdata?.find((al) => (al.equipment === row.id && al.closed === 0 && !(al.acquitment?.acquited === "yes"))) ? 2
        : alarmsdata?.find((al) => (al.equipment === row.id && al.closed === 0 && !(al.acquitment?.acquited === "yes"))) ? 1
          : 0,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => <div style={{ cursor: 'pointer' }} onClick={openalert(row)}>{
        alarmsdata?.find((al) => (al.equipment === row.id && al.closed === 0 && !(al.acquitment?.acquited === "yes"))) ?
          <Tooltip title={equipmenttext.activealarms}><NotificationsActiveIcon sx={{ color: "#f44336" }} fontSize="medium" /></Tooltip>
          : alarmsdata?.find((al) => (al.equipment === row.id && al.closed === 0 && !(al.acquitment?.acquited === "yes"))) ?
            <Tooltip title={equipmenttext.nonacquitedalarms}><NotificationsIcon sx={{ color: "#FF763A" }} fontSize="medium" /></Tooltip>
            : <Tooltip title={equipmenttext.noalarms}><CheckSharpIcon sx={{ color: "#91c241" }} fontSize="medium" /></Tooltip>
      }</div>
    },
    // {
    //   name: equipmenttext.group,
    //   selector: (row) => row.groupid,
    //   sortable: true,
    //   maxWidth: "10rem",
    //   cell: (row) => groupInfoListById["" + row.groupid] || ""
    // },
  ];

  const openalert = (row) => async () => {
    let eqalarms = alarmsdata.filter((al) => al.equipment === row.id);
    if (eqalarms) {
      setEquipmentalarmsdata(eqalarms);
      handleClickAlertOpen();
    }
  };


  const ExpandableComponent = props => {
    const { data } = props;
    const datadisplay = pointsdata.filter((x) => x.equipment === data.id);

    return (
      <Container>

      </Container>
    );
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const handleSelectedRowsChange = (selection) => {
    if (displaymethod === 'equipments')
      setEquipments(selection.selectedRows);
    else if (displaymethod === 'points')
      setPoints(selection.selectedRows);
  };

  return (
    <>
      <DataTable
        paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
        noDataComponent={<NoData>Aucun équipement à afficher</NoData>}
        noHeader={true}
        columns={equipmentscolumns}
        persistTableHead
        pagination
        subHeader
        onSelectedRowsChange={handleSelectedRowsChange}
        selectableRows={true}
        progressPending={gridState.loading}
        progressComponent={<LinearProgress />}
        paginationComponentOptions={{
          noRowsPerPage: false,
          rowsPerPageText: "Lignes par page",
          rangeSeparatorText: "sur",
          selectAllRowsItem: false,
          selectAllRowsItemText: "Selectionner toutes les lignes",
        }}
        {...gridState}
      />
      <Dialog
        onClose={handleClickAlertClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        inputProps={{
          name: 'max-width',
          id: 'max-width',
        }}
        maxWidth="xl"
        open={alertopen}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleClickAlertClose}>
          {equipmenttext.alarms}
        </CustomDialogTitle>
        <DialogContent dividers>
          <ViewEquipmentAlarmsDialog
            alarmsdata={equipmentalarmsdata}
            closeModal={handleClickAlertClose}
            refetch={handleRefreshAlarms}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </>
  );
};

export default RTEquipments;
